import { ItemView, locale } from '@glu/core';

import template from '../text.hbs';

export default ItemView.extend({
  template,
  className: 'glu-content-empty',

  initialize(options) {
    this.resultsName = options.resultsName || locale.get('records');
  },

  templateHelpers() {
    const { text } = this.options;
    const thereIsNoContent = locale.get('thereIsNoContent', this.resultsName);

    return {
      text: text || thereIsNoContent
    };
  }
});
